import { render, staticRenderFns } from "./MarketsSelector.vue?vue&type=template&id=4d60fa09&scoped=true"
import script from "./MarketsSelector.vue?vue&type=script&lang=js"
export * from "./MarketsSelector.vue?vue&type=script&lang=js"
import style0 from "./MarketsSelector.vue?vue&type=style&index=0&id=4d60fa09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60fa09",
  null
  
)

export default component.exports